import advertisersManifest from 'store/domains/getuniq/advertisers.manifest'
import partnersManifest from 'store/domains/getuniq/partners.manifest'
import recommendationsManifest from 'store/domains/getuniq/recommendations.manifest'
import servicesManifest from 'store/domains/common/services.manifest'
import financeManifest from 'store/domains/common/finance.manifest'
import {
  servicesEntries as accountTransferServicesEntries,
  financeEntries as accountTransferFinanceEntries,
} from 'store/domains/getuniq/accountTransfer.manifest'
import { commonDomains } from './common'

export default {
  recommendations: {
    manifest: recommendationsManifest,
    i18nNamespaces: ['recommendations', 'audits', 'benchmarks'],
  },
  advertisers: {
    manifest: advertisersManifest,
    i18nNamespaces: ['advertisers', 'services'],
  },
  partners: {
    manifest: partnersManifest,
    i18nNamespaces: ['partners_program', 'reward_calculator'],
  },
  services: {
    manifest: [...servicesManifest, ...accountTransferServicesEntries],
    i18nNamespaces: [...commonDomains.services.i18nNamespaces, 'account_transfer'],
  },
  finance: {
    manifest: [...financeManifest, ...accountTransferFinanceEntries],
    i18nNamespaces: [...commonDomains.finance.i18nNamespaces, 'account_transfer'],
  },
}
